<form [formGroup]="form">
	<div class="row" *ngIf="!isPersonneMorale">
		<div class="col-6">
			<div class="form-group">
				<label class="form-label form-label-required" translate="Labels.PaysResidence"></label>
				<ng-select
					[appendTo]="modalContent"
					labelForId="field-paysResidenceIdField"
					formControlName="paysResidenceId"
					[class.is-invalid]="paysResidenceIdField?.dirty && paysResidenceIdField?.invalid"
					[searchable]="true"
					[placeholder]="'Forms.Placeholder.Select' | translate"
					[notFoundText]="'NgSelect.NotFoundText' | translate"
					[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
					[loadingText]="'NgSelect.LoadingText' | translate"
					[clearAllText]="'NgSelect.ClearAllText' | translate"
					[clearable]="false"
				>
					<ng-option *ngFor="let currentPays of pays$ | async" [value]="currentPays.id">
						{{ currentPays.nom }}
					</ng-option>
				</ng-select>
				<form-control-feedback style="position: absolute" [field]="paysResidenceIdField"></form-control-feedback>
			</div>
		</div>
	</div>

	<div class="row" *ngIf="paysResidenceIdField?.value == defaultPay?.id || (paysPersonneMoraleId === defaultPay?.id && isPersonneMorale)">
		<div class="form-group" *ngIf="!isToConsult">
			<label class="form-label form-label" translate="Labels.AdressePostale"></label>
			<ng-select
				[appendTo]="modalContent"
				labelForId="field-adressePostale"
				[searchable]="true"
				[notFoundText]="'NgSelect.NotFoundText' | translate"
				[typeToSearchText]="'NgSelect.StartSearch' | translate"
				[loadingText]="'NgSelect.LoadingText' | translate"
				[typeahead]="searchTerm"
				(input)="onInput($event)"
				(change)="onChange($event)"
			>
				<ng-option *ngFor="let adr of apiAdresses" [value]="adr">
					{{ adr.label }}
				</ng-option>
			</ng-select>
			<div class="form-feedbacks" *ngIf="!isAdresseSelected">
				<div class="invalid-feedback">
					{{ 'ValidationErrors.adresseNonTrouvee' | translate }}
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="form-group">
			<label class="form-label form-label" translate="Labels.Adresse"></label>
			<input id="field-adresse" class="form-control" formControlName="adresse" (blur)="onBlur()" [maxlength]="250" />
		</div>
	</div>

	<div class="row">
		<div class="col-4">
			<div class="form-group">
				<label class="form-label form-label" translate="Labels.CodePostal"></label>
				<input id="field-codePostal" class="form-control" formControlName="codePostal" (blur)="onBlur()" [maxlength]="10" />
			</div>
		</div>

		<div class="col-8">
			<div class="form-group">
				<label class="form-label form-label" translate="Labels.Ville"></label>
				<input id="field-ville" class="form-control" formControlName="ville" (blur)="onBlur()" [maxlength]="100" />
			</div>
		</div>
	</div>
</form>
